(() => {
  if (window.__cartDrawerV2QuantitySelectorInitialised) {
    return;
  }

  window.__cartDrawerV2QuantitySelectorInitialised = true;

  const selectorRoot = '[data-cart-drawer-v2-quantity-selector]';
  const selectorAction = '[data-cart-drawer-v2-quantity-selector-action]';

  let activeSelector = null;

  const setLoadingState = (selector, isLoading) => {
    if (!selector) {
      return;
    }

    selector.classList.toggle('is-loading', isLoading);

    selector.querySelectorAll(selectorAction).forEach((button) => {
      button.setAttribute('aria-disabled', String(isLoading));

      if (isLoading) {
        button.setAttribute('tabindex', '-1');
      } else {
        button.removeAttribute('tabindex');
      }
    });
  };

  const clearLoadingState = (requestState) => {
    if (!requestState?.info?.cartDrawerV2QuantitySelector) {
      return;
    }

    if (activeSelector?.isConnected) {
      setLoadingState(activeSelector, false);
    }

    activeSelector = null;
  };

  const getCurrentQuantity = (selector) => {
    const quantityFromData = Number(selector.dataset.currentQuantity);

    if (Number.isFinite(quantityFromData)) {
      return quantityFromData;
    }

    const quantityText = selector.querySelector('.cart-drawer-v2__line__quantity-selector__quantity')?.textContent?.trim();
    const quantityFromText = Number(quantityText);

    return Number.isFinite(quantityFromText) ? quantityFromText : null;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(selectorAction);

    if (!trigger) {
      return;
    }

    const selector = trigger.closest(selectorRoot);

    if (!selector) {
      return;
    }

    if (window.liquidAjaxCart?.processing) {
      event.preventDefault();
      return;
    }

    if (!window.liquidAjaxCart?.change) {
      return;
    }

    const line = Number(selector.dataset.lineIndex);
    const currentQuantity = getCurrentQuantity(selector);

    if (!Number.isInteger(line) || line < 1 || currentQuantity === null) {
      return;
    }

    const delta = trigger.dataset.cartDrawerV2QuantitySelectorAction === 'increase' ? 1 : -1;
    const nextQuantity = Math.max(currentQuantity + delta, 0);

    event.preventDefault();

    activeSelector = selector;
    setLoadingState(selector, true);

    window.liquidAjaxCart.change(
      {
        line,
        quantity: nextQuantity,
      },
      {
        info: {
          cartDrawerV2QuantitySelector: true,
        },
      }
    );
  });

  document.addEventListener('liquid-ajax-cart:request-end', (event) => {
    clearLoadingState(event.detail?.requestState);
  });
})();
